{
    "UI_Container_Title": "Configuration complète du compte",
    "UI_Container_Description": "Entrez votre nom complet et un mot de passe pour terminer l'enregistrement.",
    "UI_Name_Placeholder": "Nom complet",
    "UI_Name_Label": "Nom complet",
    "UI_Password_Placeholder": "Mot de passe",
    "UI_Password_Label": "Mot de passe",
    "UI_PasswordLengthValidation": "Le mot de passe est trop court",
    "UI_PasswordRequiredValidation": "Le mot de passe ne doit pas être vide",
    "UI_PasswordStrengthValidation": "Le mot de passe n'est pas assez fort (assurez-vous d'inclure des lettres majuscules et minuscules ainsi que des chiffres).",
    "UI_Footer_Server_Error": "Erreur du serveur",
    "UI_Footer_Submit_Button": "Soumettre",
    "UI_NameRequiredValidation": "Veuillez saisir votre nom",
    "NAME": "UserInvite"
}